import React, { useEffect, useState } from 'react';
import { TagIcon, CheckIcon } from 'lucide-react';
export function OffersDealOfDay() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 9,
    minutes: 45,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            hours: prev.hours,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="container mx-auto px-4 py-6" data-id="element-4419" data-mp="df1pxxnhgjc8">
      <div className="flex items-center justify-between mb-4" data-id="element-4420" data-mp="9g17ig8x3ipr">
        <div className="flex items-center" data-id="element-4421" data-mp="9hm0i1fl2tli">
          <TagIcon className="w-6 h-6 text-red-600 mr-2" data-id="element-4422" data-mp="3n5xsg365eg83" />
          <h2 className="text-2xl font-bold" data-id="element-4423" data-mp="3s62a3wislgzw">Deals of the Day</h2>
        </div>
        <a href="#" className="text-sm font-medium text-[#723881] hover:underline" data-id="element-4424" data-mp="3s86o57aenwdw">
          View All Deals
        </a>
      </div>
      <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl border border-amber-100 p-6 relative overflow-hidden" data-id="element-4425" data-mp="50bb9id7qa1k">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6" data-id="element-4426" data-mp="34ic9qlaftzrj">
          <div className="md:col-span-3 relative" data-id="element-4427" data-mp="38j4kxk2veeqg">
            <div className="absolute top-0 left-0 z-10" data-id="element-4428" data-mp="38fqmgmxbupoa">
              <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-4429" data-mp="3dgeaczq9eqea">
                60% OFF
              </span>
            </div>
            <div className="bg-white rounded-lg p-6 flex items-center justify-center" data-id="element-4430" data-mp="2kss3nilqj5n7">
              <img src="https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png" alt="Product" className="max-h-64 object-contain" data-id="element-4431" data-mp="2prlj3gkl16q0" />
            </div>
          </div>
          <div className="md:col-span-6 flex flex-col justify-center" data-id="element-4432" data-mp="3o2cy1m96kxxc">
            <div className="mb-3" data-id="element-4433" data-mp="5pye2qihajek">
              <span className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-4434" data-mp="5o58zfnik78o">
                EXPRESS DELIVERY
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold mb-2" data-id="element-4435" data-mp="3a34xoq1a7jrk">
              Nitro-Tech Whey Gold Protein - Vanilla
            </h3>
            <div className="flex items-center mb-3" data-id="element-4436" data-mp="355va7fxgdi6d">
              <div className="flex" data-id="element-4437" data-mp="3j436dlmo0fgh">
                {[...Array(5)].map((_, i) => <svg key={i} className={`w-4 h-4 ${i < 4 ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-id="element-4438" data-mp="3e58cnon5t6hl" data-mpi={i}>
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-4439" data-mp="terfv3ls7lh3" />
                  </svg>)}
              </div>
              <span className="text-sm text-gray-600 ml-2" data-id="element-4440" data-mp="15yektfepd1na">(214 reviews)</span>
            </div>
            <div className="flex items-baseline mb-4" data-id="element-4441" data-mp="rz5gpe3rtxzo">
              <span className="text-3xl text-red-600 font-bold" data-id="element-4442" data-mp="wwouye0gyarm">21.99 SAR</span>
              <span className="text-gray-500 line-through text-lg ml-2" data-id="element-4443" data-mp="wyrvhrz8zmal">
                54.99 SAR
              </span>
            </div>
            <p className="text-gray-700 text-sm mb-4" data-id="element-4444" data-mp="1pm48pbjiqhr8">
              Pure protein with 24g of ultra-premium micro-filtered protein and
              5.5g of naturally occurring BCAAs per serving.
            </p>
          </div>
          <div className="md:col-span-3 flex flex-col justify-center bg-white rounded-lg p-6 border border-amber-200" data-id="element-4445" data-mp="1fuhwpczcwenf">
            <div className="text-center mb-4" data-id="element-4446" data-mp="23k2fnvvifbwp">
              <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-4447" data-mp="28clxx6556v7u">
                Today's Special Price
              </h4>
              <p className="text-sm text-gray-600 mb-2" data-id="element-4448" data-mp="jr2fidil0nth">
                Hurry! Offer ends in:
              </p>
              <div className="flex justify-center gap-2" data-id="element-4449" data-mp="fn4h6512zh1h">
                <div className="bg-[#1E2B55] text-white font-bold rounded px-3 py-2 text-xl min-w-[50px] text-center" data-id="element-4450" data-mp="ap2wjfo0b9nw">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <span className="text-xl font-bold flex items-center" data-id="element-4451" data-mp="13es1g43u7tus">:</span>
                <div className="bg-[#1E2B55] text-white font-bold rounded px-3 py-2 text-xl min-w-[50px] text-center" data-id="element-4452" data-mp="yf72htoo3li2">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <span className="text-xl font-bold flex items-center" data-id="element-4453" data-mp="opneyaq0f3gv">:</span>
                <div className="bg-[#1E2B55] text-white font-bold rounded px-3 py-2 text-xl min-w-[50px] text-center" data-id="element-4454" data-mp="onjds0jhwika">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-4455" data-mp="1opzalhk60c3c">
              <button className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-lg transition-colors" data-id="element-4456" data-mp="1or0n7qgtx6n6">
                Add to Cart
              </button>
              <button className="w-full border-2 border-[#723881] text-[#723881] hover:bg-[#723881] hover:text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-4457" data-mp="1ymkhy9jnpzac">
                Buy Now
              </button>
            </div>
            <div className="mt-4 flex items-center justify-center text-sm text-gray-600" data-id="element-4458" data-mp="27m7jqwgat73x">
              <CheckIcon className="w-4 h-4 mr-1 text-green-600" data-id="element-4459" data-mp="2cl20ztymanlx" />
              <span data-id="element-4460" data-mp="2hf68cebsoxnj">1289 sold in last 24 hours</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}